<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-primary">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3  text-white">お問い合わせ
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">プライバシーポリシー</h2>
            <p class="lead">雛菊書房では、お問い合わせの際に収集した個人情報について、以下のプライバシーポリシーに基づいて管理いたします。</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-12">
            <p class="lead">個人情報の取得・利用目的</p>
            <p>雛菊書房は、お問い合わせの際に入手した個人情報について、以下の目的のために収集・利用いたします。何れの情報も、ユーザの同意無しに以下の情報を取得・収集いたしません。</p>
            <ol>
              <li>メールアドレス・電話番号・住所・その他連絡先情報について、お問い合わせ内容に関する返答及びその後の連絡を行う目的</li>
              <li>氏名・その他個人識別情報について、ユーザを一意に識別し、問い合わせ内容に対する適切な回答を行う目的</li>
              <li>キャッシュレス決済異議申立の場合、お支払い情報について、当該決済内容の確認、取消、修正を行う目的</li>
              <li>その他、ユーザに個別に通知した目的</li>
              <li>その他上記に付随する情報について、上記のの利用目的</li>
            </ol>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-12">
            <p class="lead">個人情報の第三者提供</p>
            <p>雛菊書房は、次に掲げる場合を除いて、予めユーザの同意を得ることなく、第三者に個人情報を提供することはありません。</p>
            <ol>
              <li>既に当該第三者に対して、ユーザが個別に情報提供の同意をしていることが明らかな場合</li>
              <li>利用目的に第三者への提供を含む場合</li>
              <li>個人情報の保護に関する法令、およびその他法令及び日本国内において法的に有効な契約等に基づく場合</li>
              <li>国の機関若しくは地方公共団体、またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要があり、本人の同意を得ることにより当該事務の遂行に支障を及ぼす恐れがある場合</li>
            </ol>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-12">
            <p class="lead">個人情報の管理</p>
            <p>雛菊書房は、個人情報を適切に管理するため、内部の運営体制の徹底及び従事者の教育を行います。また、外部への流出防止だけでなく、情報の紛失、破壊、改ざん、外部からの不正アクセス等の危険に対して、適切かつ合理的なレベルの安全対策を実施し、ユーザの個人情報の保護に努めます。</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-12">
            <p class="lead">個人情報の削除および利用停止</p>
            <p>雛菊書房は、収集したユーザの個人情報が必要でなくなった場合は遅滞なく、その個人情報を保管しているすべての場所から削除します。 また、本人から個人情報の削除の請求及び利用停止の請求を受けた場合は、遅滞なくその個人情報を削除・利用停止し、本人にこれを通知いたします</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">お問い合わせ</h2>
            <p class="lead text-white">雛菊書房ならびに小鳥遊　昴に対するお問い合わせははメール（info@hinagiku-books.jp）からよろしくお願いします。<br>
              なお、大変恐れ入りますがお問い合わせの前に以下ご確認下さい。</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon name="fa fa-twitter" size="lg" gradient="white" shadow round color="primary"></icon>
            <h5 class="text-white mt-3">Twitterなどでの問合せ</h5>
            <p class="text-white mt-3">主に個人からの問合せについては、以下に該当しない場合はTwitterのDMからお問い合わせ下さい。</p>
            <ul>
              <li class="text-white">個人情報を含む問合せの場合</li>
              <li class="text-white">問い合わせ内容、応答などの保全が法的に/契約上要求される場合</li>
              <li class="text-white">当該内容がTwitterのポリシーに違反する投稿となる場合</li>
            </ul>
            <p class="text-white mt-3">また、BOOTHでの注文に関するお問い合わせは、大変恐れ入りますがBOOTH内の問合せチャットでの
            お問い合わせをお願いいたします（注文情報との突き合わせが必要なためです）。</p>
          </div>
          <div class="col-lg-4">
            <icon name="fa fa-clock-o" size="lg" gradient="white" shadow round color="primary"></icon>
            <h5 class="text-white mt-3">お問合せの返信について</h5>
            <p class="text-white mt-3">特に返答を要するお問い合わせについては、迅速な応答を心がけております。但し、何らかの確認を要する
            ものや、発信者の正当性検証が必要なもの、雛菊書房及び小鳥遊 昴で完結しない事案につきましては、返答にお時間を頂戴することがございます。
            お急ぎの所ご迷惑をおかけしており申し訳ございませんが、ご返答までしばらくお待ちいただきたく、よろしくお願いします。</p>
          </div>
          <div class="col-lg-4">
            <icon name="fa fa-pencil-square-o" size="lg" gradient="white" shadow round color="primary"></icon>
            <h5 class="text-white mt-3">記入をお願いしたい事項</h5>
            <p class="text-white mt-3">迅速な対応のため、お問い合わせ時には、以下の内容を必ずご記入下さい。</p>
            <ul>
              <li class="text-white">氏名（本名）</li>
              <li class="text-white">法人/団体からのお問い合わせの場合、法人/団体名</li>
              <li class="text-white">要件の詳細（可能な限り詳細にご記入下さい）</li>
              <li class="text-white">キャッシュレス決済に関する申立の場合、該当決済に関する情報</li>
              <li class="text-white">返答の要否及び希望する返答期限（※必ずこの期限を守ることを保証するものではございません）</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - お問い合わせ' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」へのお問い合わせはこちら' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
};
</script>
<style>
</style>
